import gP1_img from './goat01.webp'
import gP2_img from './goat02.webp'
import gP3_img from './goat03.png'
import gP4_img from './goaT.webp'
import sP1_img from './sheep01.jpg'
import cP1_img from './cow01.jpg'
import cP2_img from './cow02.avif'
import cP3_img from './cow03.jpg'
import cP4_img from './cow04.jpg'
import cM1_img from './camel01.jpeg'
import cM2_img from './camel02.webp'
import cM3_img from './camels001.jpeg'


let all_product = [
    {
        id:1,
        name:'Boer Goat', // Corrected "Boerer" to "Boer"
        category:"Goats",
        image:gP1_img,
        newPrice:10000,
        oldPrice:11000,
        info: "Known for their rapid growth and excellent meat quality, Boer goats are a top choice for commercial farming. Robust and adaptable.",
    },
    {
        id:2,
        name:'Boran Goat',
        category:"Goats",
        image:gP2_img,
        newPrice:9500,
        oldPrice:10000,
        info: "Hardy and resilient, the Boran goat thrives in arid conditions. Ideal for meat production, offering good yields even in challenging environments.",
    },
    {
        id:3,
        name:'Turkana Goat',
        category:"Goats",
        image:gP3_img,
        newPrice:10000,
        oldPrice:12000,
        info: "Perfect for pastoralist communities and sustainable farming.",
    },
    {
        id:4,
        name:'Dairy Goat',
        category:"Goats",
        image:gP4_img,
        newPrice:9000,
        oldPrice:11000,
        info: "High-producing dairy goats, selected for their consistent milk yield and calm temperament. An excellent addition for fresh milk supply.",
    },
    {
        id:5,
        name:'Sheep', // Consider being more specific, e.g., "Dorper Sheep"
        category:"Sheeps",
        image:sP1_img,
        newPrice:9500,
        oldPrice:10000,
        info: "Robust and adaptable, these sheep are prized for both their meat and wool. Easy to manage and suitable for various grazing conditions.",
    },
    {
        id:6,
        name:'Boran Cow',
        category:"Cows",
        image:cP1_img,
        newPrice:75000,
        oldPrice:80000,
        info: "A highly resilient beef cattle breed, known for its disease resistance and ability to thrive in harsh environments. Excellent for meat production.",
    },
    {
        id:7,
        name:'Dairy Cow', // If you have multiple dairy cows, consider differentiating them
        category:"Cows",
        image:cP2_img,
        newPrice:70000,
        oldPrice:70000,
        info: "A high-yielding dairy cow, offering significant milk production. Ideal for commercial dairy operations seeking consistent output.",
    },
    {
        id:8,
        name:'Dairy Cow', // Consider specifying breed, e.g., "Friesian Dairy Cow"
        category:"Cows",
        image:cP4_img,
        newPrice:50000,
        oldPrice:55000,
        info: "Another reliable dairy cow, noted for its adaptability and steady milk production. A valuable asset for small to medium-scale dairies.",
    },
    {
        id:9,
        name:'North Eastern Camel',
        category:"Camels",
        image:cM2_img,
        newPrice:90000,
        oldPrice:100000,
        info: "Known for their endurance and ability to traverse long distances in arid regions. Ideal for transport and milk production in dry climates.",
    },
    {
        id:10,
        name:'Turkana Camel',
        category:"Camels",
        image:cM1_img,
        newPrice:100000,
        oldPrice:120000,
        info: "A highly sought-after camel breed from Turkana, renowned for its strength, resilience, and adaptability to extreme conditions.",
    },
    {
        id:11,
        name:'Camels', // Consider being more specific, e.g., "Young Dromedary Camel"
        info: "Versatile and robust camels, suitable for various purposes including transport, milk, and meat. A staple for pastoralist livelihoods.",
        category:"Camels",
        image:cM3_img,
        newPrice:90000,
        oldPrice:95000,
    },
    {
        id:12,
        name:'Bulls', // Consider specifying breed, e.g., "Shorthorn Bull"
        category:"Cows", // Bulls are male cattle, so 'Cows' category works, or you could make a 'Cattle' category
        image:cP3_img,
        newPrice:100000,
        oldPrice:105000,
        info: "perfect for breeding programs to enhance herd genetics and productivity. Vital for robust livestock farming.",
    }
];
export default all_product;